export default __webpack_public_path__ + "static/media/project-symptomchecker.b1a166e2.jpg";